import React from 'react';
import { components } from 'react-select';

import {
  CheckBox,
  CheckboxWrapper,
  Input,
} from 'components/common/form/withoutFormik/CheckboxField/index.styled';
import { useTheme } from 'styled-components';

export const InputOption = ({
  getStyles,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}: any) => {
  const { colors } = useTheme();

  let bg = 'transparent';
  if (isFocused) bg = colors.black_10;

  const style = {
    display: 'flex ',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: bg,
    color: isDisabled ? colors.black_40 : colors.black_100,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
  };

  // prop assignment
  const props = {
    ...innerProps,
    style,
  };

  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      <CheckboxWrapper marginRight="0.75rem">
        <Input checked={isSelected} type="checkbox" readOnly />
        <CheckBox />
      </CheckboxWrapper>

      {children}
    </components.Option>
  );
};
